<template>
  <div class="meal-tab-page meal-menu-page">
    <van-notice-bar mode="closeable" left-icon="volume-o">
      <span v-if="disabled">超过点餐时间，名单已提交！</span>
      <span v-else>温馨提示：订餐截止时间为13:30</span>
    </van-notice-bar>
    <div class="meal-menu" v-if="menuList.length">
      <dl v-for="(item,i) in menuList" :key="i">
        <dt>{{ item.name }}</dt>
        <dd>
          <span
            v-if="food"
            :key="food"
            v-for="food in item.detail.split(/[,，\s]/)"
            >{{ food }}</span
          >
        </dd>
      </dl>
    </div>
    <div class="meal-choose" v-for="order in orderList" :key="order.id">
      <div class="header van-hairline--bottom">
        <span class="title">{{ order.obtainDate }}日加班餐</span>
        <span class="note">可顺延到{{ order.endDate }}号</span>
      </div>
      <div class="action">
        <van-button
          :class="order.menuId === item.id ? 'van-button--active' : ''"
          @click="handleOrderMeal(order, item)"
          :disabled="disabled"
          round
          plain
          :key="item.id"
          v-for="item in menuList"
          >{{ item.name }}</van-button
        >
      </div>
    </div>
    <div class="meal-order-tip" v-if="tipTxt">
      <div v-if="!menuList.length" class="noDataImg"></div>
      {{ tipTxt }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import * as mealApi from '@api/meal';
import {
  NoticeBar,
  Button,
  Icon,
  Image,
  Popup,
  Toast,
  Dialog,
  Loading,
  Rate,
  Grid,
  GridItem,
} from 'vant';

// 一次性引入常用组件
[
  NoticeBar,
  Button,
  Icon,
  Image,
  Popup,
  Toast,
  Dialog,
  Loading,
  Rate,
  Grid,
  GridItem,
].forEach(item => {
  if (item.install) {
    Vue.use(item);
  }
});

export default {
  data() {
    return {
      menuList: [],
      orderList: [],
      disabled: false,
      tipTxt: '',
      timer: null,
    };
  },
  mounted() {
    this.initMenuList();
    this.initOrderOrderList();

    this.setDisabled();
    this.timer = setInterval(() => {
      this.setDisabled();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    /**
     * 13:30后页面不可编辑
     */
    setDisabled() {
      const timeRange = [0, 13 * 60 + 30];
      this.disabled = !this.$utils.hasInTimeRange(timeRange);
      // TODO...
      // this.disabled = false;
    },
    /**
     * 初始化菜单
     */
    async initMenuList() {
      const res = await mealApi.mealList();
      this.menuList = res || [];
      if (!this.menuList.length) {
        this.tipTxt = '暂无可点的菜单~';
      }
    },
    /**
     * 初始化点餐列表
     */
    async initOrderOrderList() {
      const res = await mealApi.mealOrderList();
      this.orderList = res.content || [];
      if (!this.orderList.length && !this.tipTxt) {
        this.tipTxt = '暂无订餐资格~';
      }
    },
    /**
     * 点餐/取消点餐
     */
    async handleOrderMeal(order, item) {
      if (order.menuId === item.id) {
        await mealApi.mealCancelOrder({
          orderId: order.id,
        });
        this.$set(order, 'menuId', '');
        Toast.success('已取消点餐！');
      } else {
        await mealApi.mealOrder({
          menuId: item.id,
          orderId: order.id,
        });
        this.$set(order, 'menuId', item.id);
        Toast.success('点餐成功！');
      }
    },
  },
};
</script>

<style lang="scss">
// .noDataImg {
//   height: 262px;
//   margin-bottom: 20px;
//   background: url('../../assets/image/no_arrange.png') no-repeat center;
// }
.noDataImg {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
  background: url(https://web-data.zmlearn.com/image/kY3xqpeL2t4RRGdd43Sqdx/meal_no_result.png) no-repeat center
    center;
  background-size: cover;
  margin: 0 auto;
}
// .meal-manage-page {
//   font-size: 16px;
// }
.meal-menu-page {
  .van-tabs__content {
    margin-top: 20px;
  }
  .meal-menu {
    min-height: 780px;
    background: url(https://web-data.zmlearn.com/image/r16nRHrAi6DjGpihW9619r/meal_bg.png) no-repeat center 0;
    background-size: 100% auto;
    padding: 260px 120px 0 120px;
    font-size: 28px;
    line-height: 50px;
    dl {
      overflow: hidden;
      margin-bottom: 20px;
    }
    dt {
      float: left;
    }
    dt {
      font-size: 40px;
    }
    dd {
      margin-left: 40px;
      span {
        margin-left: 12px;
      }
    }
  }
  // .van-grid {
  //   padding-left: 10px!important;
  //   padding-right: 5px;
  // }
  .van-grid-item {
    color: #fff;
  }
  .van-grid-item__icon-wrapper {
    font-size: 36px;
    padding-right: 8px;
    position: static;
    // color: yellow;
    // color: #e3c91a;
    color: #fff;
    z-index: 999;
    .van-info {
      right: 0px;
      top: -7px;
      transform: none;
      color: #fff;
    }
  }
  ul {
    z-index: 999;
    font-size: 24px;
  }
  .van-grid-item__content--surround::after {
    border-radius: 20px;
    border-width: 0;
    // background: #07c160;
    // background: #8bc34a;
    background: #f16014;
  }
  .meal-order-tip {
    text-align: center;
    font-size: 32px;
    color: #999;
    padding-top: 100px;
  }
  .meal-choose {
    margin-top: 80px;
    padding: 0 40px;
    overflow: hidden;
    .header {
      padding-bottom: 16px;
      font-size: 28px;
    }
    .note {
      float: right;
    }
    .action {
      text-align: center;
      margin-top: 20px;
    }
    .van-button {
      margin: 0 5px;
      font-size: 24px;
      width: 46px;
      height: 46px;
    }
    .van-button--normal {
      background: #a1a1a1;
      color: #fff;
    }
    .van-button--active {
      background-color: #07c160;
    }
  }
}
</style>
